import { useQuery } from '@tanstack/react-query'
import { useApiFetch } from '../../shared/api/useApiFetch'
import { useAuth } from '../../shared/auth/useAuth'

export interface DistrictSummary {
  id: string
  name: string
}

/** The districts the signed-in user belongs to (id + name), for the switcher. */
export function useAvailableDistricts() {
  const { state } = useAuth()
  const call = useApiFetch()
  const uid = state.status === 'signed-in' ? state.user.uid : null
  return useQuery({
    queryKey: ['availableDistricts', uid],
    queryFn: () => call<DistrictSummary[]>('/api/v1/districts'),
    enabled: state.status === 'signed-in',
    staleTime: 60_000,
  })
}
